import { Component, OnInit, OnChanges, ViewChild } from '@angular/core';
import { deepCopy } from '@delon/util';
import { DialogService } from '../../services/dialog.service';
import * as $ from 'jquery';
import { NzModalRef } from 'ng-zorro-antd';
import { ModalHelper, _HttpClient } from '@delon/theme';
import { IccMediaSelectComponent } from '../icc-media-select/icc-media-select.component';
import { apiPrefix, telPhoneReg, webUrlReg } from '../../utils/constants';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { IccMapPositionComponent } from '../icc-map-position/icc-map-position.component';
import { IccShortChainConfigComponent } from '../icc-short-chain-config/icc-short-chain-config.component';
import { _MSGTYPES } from '../../constant/msgType';
import { format } from 'date-fns';
import { URLS } from '../../constant/interface';

@Component({
  selector: 'app-card',
  templateUrl: './icc-5Gcard.component.html',
  styleUrls: ['./icc-5Gcard.component.less'],
})
export class Icc5GCardComponent implements OnInit, OnChanges {
  constructor(public http: _HttpClient, private dialogService: DialogService, private modal: NzModalRef, private modalHelper: ModalHelper) {}
  @ViewChild('materialTab', { static: false }) materialTab;
  suggestionActions = [
    {
      label: '电话拨打',
      value: 1,
    },
    { label: '链接跳转', value: 2 },
    { label: '消息上行', value: 3 },
    { label: '获取终端位置', value: 4 },
    { label: '发送地理位置', value: 5 },
    { label: '共享终端信息', value: 6 },
    { label: '视频通话', value: 7 },
    { label: '创建日历', value: 8 },
  ];
  mode: 'edit' | 'view' = 'edit';
  imgContentType: 'image/png';
  videoContentType: 'video/png';
  // 日历信息暂存
  calendarInfo = null;

  // 当前 编辑/查看 日历 suggestion
  currentSuggestionIndex: number = 0;

  // 是否显示日历编辑弹窗
  isShowCalendarModal = false;
  // 是否编辑日历
  isEditCalendar = true;
  // 日历标题
  calendarTitle = '';
  // 起止时间范围
  timeRange = [];
  // timeRange = [getStartDate(new Date(), -1), getEndDate(new Date(), -2)];

  uuid: string;
  card = {
    title: null,
    description: '',
    media: {
      id: null,
      type: 0,
      ftpUrl: null,
      mediaUrl: null,
      mediaContentType: null,
      mediaName: null,
      mediaUntil: null,
      mediaFileSize: 0,
      thumbnailUrl: null,
      thumbnailContentType: null,
      thumbnailName: null,
      thumbnailUntil: null,
      thumbnailFileSize: 0,
    },
    suggestions: [],
  };

  // 是否模版编辑
  isTplEdit = true;

  defaultSuggestion = {
    action: 1,
    text: null,
    param: {
      extInfo: '',
      link: {
        longUrl: '',
        longUrlName: '',
        serverUrl: '',
        traceType: 0, // 0普通链接，1小程序链接
        // 生成短链的形式参数：
        uuid: '',
        targetUrl: '',
      },
      map: {
        longitude: null,
        latitude: null,
        currentTude: '',
      },
    },
  };
  variableBinds = [];
  channelIds: any[] = [];
  sugTmp = null;
  emptyData = [];
  editIndex = -1;
  isUpdate = false;
  imgList = [];
  videoUrl = null;
  vIndex = -1;
  mediaUrl = apiPrefix + '/common/downloadMaterial/';
  telPhoneReg = telPhoneReg;

  // 跳转链接名
  longUrlName: string = '';

  // 自动回复列表
  autoReplyList = [];

  // 关键字搜索
  search5GReplyChange$ = new Subject();

  webUrlReg = webUrlReg;
  /** 描述的最大长度 */
  maxLengthForDes = 300;
  addSuggestion() {
    if (this.editIndex !== -1) {
      this.dialogService.notification.error('卡片建议', '请先保存正在编辑的行');
      return;
    }
    if (this.card.suggestions.length >= 4) {
      this.dialogService.notification.error('卡片建议', '卡片内最多只能录入四个事件');
      return;
    }
    this.card.suggestions.push(deepCopy(this.defaultSuggestion));
    this.setEditTmpInfo(this.card.suggestions.length - 1, false, null);
  }

  deleteSuggestion(index) {
    if (this.editIndex !== -1) {
      this.dialogService.notification.error('卡片建议', '请先保存正在编辑的行');
      return;
    }
    this.card.suggestions.splice(index, 1);
    this.setEditTmpInfo(-1, null, null);
  }

  editSuggestion(index) {
    if (this.editIndex !== -1) {
      this.dialogService.notification.error('卡片建议', '请先保存正在编辑的行');
      return;
    }
    this.setEditTmpInfo(index, true, deepCopy(this.card.suggestions[index]));
  }

  saveSuggestion(index) {
    const sug = this.card.suggestions[index];
    if (!sug.action || !sug.text) {
      this.dialogService.notification.warning('卡片建议', '请正确填写必要参数');
      return;
    }
    // 验证电话拨打、消息上行、视频通话 参数必填性
    if (sug.action && sug.text && (sug.action == 1 || sug.action == 3 || sug.action == 7) && !sug.param.extInfo) {
      this.dialogService.notification.warning('卡片建议', '请正确填写必要参数');
      return;
    }
    // 验证电话拨打、视频通话 电话号码合法性
    const phonePattern = /^[0-9]*$/;
    if ((sug.action == 1 || sug.action == 7) && !phonePattern.test(sug.param.extInfo)) {
      this.dialogService.notification.warning('卡片建议', '请输入正确号码格式');
      return;
    }
    // 验证链接跳转参数必填性
    if (sug.action && sug.text && sug.action == 2 && !sug.param.link.longUrlName && !sug.param.link.targetUrl) {
      this.dialogService.notification.warning('卡片建议', '请正确填写必要参数');
      return;
    }
    // 验证发送地理位置参数必填性
    if (sug.action && sug.text && sug.action == 5 && !sug.param.map.currentTude) {
      this.dialogService.notification.warning('卡片建议', '请正确填写必要参数');
      return;
    }
    // 验证日历信息参数必填性
    if (sug.action && sug.text && sug.action == 8 && (!sug.param.calendarInfo || !sug.param.calendarInfo.title || !sug.param.calendarInfo.startTime || !sug.param.calendarInfo.endTime)) {
      this.dialogService.notification.warning('卡片建议', '请正确填写必要参数');
      return;
    }
    if (this.card.suggestions.find(s => s !== sug && s.text === sug.text)) {
      this.dialogService.notification.warning('卡片建议', `存在同名的操作按钮名称`);
      return;
    }

    this.setEditTmpInfo(-1, null, null);
  }

  cancelSuggestion(index) {
    if (!this.isUpdate) {
      this.card.suggestions.splice(index, 1);
      this.setEditTmpInfo(-1, null, null);
    } else {
      this.card.suggestions[index] = this.sugTmp;
      this.setEditTmpInfo(-1, null, null);
    }
  }

  setEditTmpInfo(editIndex, isUpdate, editTmp) {
    this.editIndex = editIndex;
    this.isUpdate = isUpdate;
    this.sugTmp = editTmp;
    this.emptyData = [...this.card.suggestions];
  }

  getCaretPosWithEvent(card, event) {
    let field = event.target;
    this.vIndex = field.selectionStart;
  }

  insertVar(card, v) {
    if (card.description == null || card.description === undefined) {
      card.description = '';
    }
    card.description = card.description.slice(0, this.vIndex) + '${' + v.code + '}' + card.description.slice(this.vIndex);
    this.vIndex = this.vIndex + v.code.length + 3;
  }

  varMouseOver(evt) {
    $(evt.target).addClass('var-active');
  }

  varMouseLeave(evt) {
    $(evt.target).removeClass('var-active');
  }

  actionChannge(evt, suggestion) {
    // 切换了类型，初始化参数 param
    suggestion.param = {
      extInfo: '',
      link: {
        longUrl: '',
        longUrlName: '',
        serverUrl: '',
        traceType: 0, // 0普通链接，1小程序链接
      },
      map: {
        longitude: null,
        latitude: null,
        currentTude: '',
      },
    };
  }

  ngOnInit() {
    // // 查询对应 channelId 的 5g消息自动回复
    this.init5GReplySearch();

    this.setEditTmpInfo(-1, null, null);
    if (this.card.media.id) {
      if (this.card.media.type === 0) {
        this.imgList = [{ url: this.mediaUrl + this.card.media.id }];
      }
      if (this.card.media.type === 1) {
        this.videoUrl = this.mediaUrl + this.card.media.id;
      }
    }
    // 初始化组件的时候将是卡片操作项param为json字符串的解析
    // if (this.card.suggestions.length > 0) {
    //   for (let i = 0; i < this.card.suggestions.length; i++) {
    //     if (isJsonString(this.card.suggestions[i].param)) {
    //       this.card.suggestions[i].param = JSON.parse(this.card.suggestions[i].param);
    //     }
    //   }
    // }
  }

  ngOnChanges() {}

  destroy() {
    if (this.editIndex !== -1) {
      this.card.suggestions.splice(this.editIndex, 1);
    }
    // // 关闭组件的时候将所有的卡片操作项的param 字段 json序列化，适配后端
    // if (this.card.suggestions.length > 0) {
    //   for (let i = 0; i < this.card.suggestions.length; i++) {
    //     if (isObject(this.card.suggestions[i].param)) {
    //       this.card.suggestions[i].param = JSON.stringify(this.card.suggestions[i].param);
    //     }
    //   }
    // }
    this.modal.triggerCancel();
  }

  confirm() {
    if ((this.materialTab.actIndex === 0 && this.imgList.length <= 0) || (this.materialTab.actIndex === 1 && !this.videoUrl)) {
      this.dialogService.notification.error('卡片建议', '请选择媒体内容');
      return;
    }
    // // 关闭组件的时候将所有的卡片操作项的param 字段 json序列化，适配后端
    // if (this.card.suggestions.length > 0) {
    //   for (let i = 0; i < this.card.suggestions.length; i++) {
    //     if (isObject(this.card.suggestions[i].param)) {
    //       this.card.suggestions[i].param = JSON.stringify(this.card.suggestions[i].param);
    //     }
    //   }
    // }
    this.modal.close(this.card);
  }

  selectMedia(event) {
    this.modalHelper.createStatic(IccMediaSelectComponent, { mediaType: event, channelIds: this.channelIds }, { size: 'lg' }).subscribe(media => {
      this.card.media.id = media.id;
      this.card.media.type = media.type;
      this.card.media.ftpUrl = media.ftpUrl;
      this.card.media.mediaUrl = media.mediaUrl;
      this.card.media.mediaContentType = media.mediaContentType;
      this.card.media.mediaName = media.mediaName;
      this.card.media.mediaUntil = media.mediaUntil;
      this.card.media.mediaFileSize = media.mediaFileSize;
      this.card.media.thumbnailUrl = media.thumbnailUrl;
      this.card.media.thumbnailContentType = media.thumbnailContentType;
      this.card.media.thumbnailName = media.thumbnailName;
      this.card.media.thumbnailUntil = media.thumbnailUntil;
      this.card.media.thumbnailFileSize = media.thumbnailFileSize;
      if (event === 'img') {
        this.imgList = [{ url: this.mediaUrl + media.id }];
      } else {
        this.videoUrl = this.mediaUrl + media.id;
      }
    });
  }

  // 点击自动回复选择框
  clickReply($event) {
    const value = ($event.target as HTMLInputElement).value;
    this.onSearch(value);
  }

  // 搜索5g关键字 根据输入的关键词查询系统中通过审核的对应渠道5g关键字
  onSearch(value) {
    if (value) {
      this.search5GReplyChange$.next(value);
    } else {
      this.search5GReplyChange$.next('');
    }
  }

  init5GReplySearch() {
    console.log('this.channelIds', this.channelIds);
    let param = {
      params: {
        msgTypes: [9],
      },
    };
    const get5GReplyList = (name: string) => this.http.post(URLS._5GAutoReply.url, param);
    const optionList$: Observable<any> = this.search5GReplyChange$.asObservable().pipe(debounceTime(300), distinctUntilChanged(), switchMap(get5GReplyList));
    optionList$.subscribe(res => {
      res.list = res.list.filter(item => {
        return item.channelId === this.channelIds[0];
      });
      this.autoReplyList = res.list.map((item: any) => {
        if (item.autoMatchExtConfigs) {
          return item.autoMatchExtConfigs[0].content;
        } else {
          return '';
        }
      });
    });
  }

  // 查询坐标
  queryPosition() {
    this.modalHelper.createStatic(IccMapPositionComponent, { currentTude: this.card.suggestions[this.editIndex].param.map.currentTude }, { size: 'lg' }).subscribe(result => {
      this.card.suggestions[this.editIndex].param.map = result;
    });
  }

  /* 打开短链配置弹窗 */
  OpenShortChainModal() {
    this.modalHelper.createStatic(IccShortChainConfigComponent, { isShortLink: true, isGeneratorLink: !this.isTplEdit, msgType: _MSGTYPES.MT._5G.type, uuid: this.uuid }, { size: 'md' }).subscribe(result => {
      if (result.targetUrl) {
        result.targetUrl = result.targetUrl + '${traceCode}';
      }
      console.log('result', result);
      this.card.suggestions[this.editIndex].param.link = result;
    });
  }

  /* 打开选择链接弹窗 */
  OpenLongChainModal() {
    this.modalHelper.createStatic(IccShortChainConfigComponent, { isShortLink: false, msgType: _MSGTYPES.MT._5G.type }, { size: 'md' }).subscribe(result => {
      console.log('result', result);
      this.card.suggestions[this.editIndex].param.link = result;
    });
  }

  // 打开日历选择弹窗
  openCalendarModal(suggestion, isEdit, index) {
    this.currentSuggestionIndex = index;
    this.isEditCalendar = isEdit;
    this.calendarTitle = suggestion.param.calendarInfo && suggestion.param.calendarInfo.title ? suggestion.param.calendarInfo.title : '';
    this.timeRange = suggestion.param.calendarInfo && suggestion.param.calendarInfo.startTime && suggestion.param.calendarInfo.endTime ? [suggestion.param.calendarInfo.startTime, suggestion.param.calendarInfo.endTime] : [];
    this.isShowCalendarModal = true;
  }

  // 确定日历创建弹窗
  handleOkCalendar() {
    if (!this.calendarTitle) {
      this.dialogService.notification.warning('创建终端日历', '请输入日历标题！');
      return false;
    }
    if (this.timeRange.length <= 0) {
      this.dialogService.notification.warning('创建终端日历', '请选择起止时间！');
      return false;
    }
    this.card.suggestions[this.currentSuggestionIndex].param.calendarInfo = {
      title: this.calendarTitle,
      startTime: this.timeRange.length > 0 ? format(this.timeRange[0], 'yyyy-MM-dd HH:mm:ss') : null,
      endTime: this.timeRange.length > 1 ? format(this.timeRange[1], 'yyyy-MM-dd HH:mm:ss') : null,
    };

    console.log(`this.card`, this.card);
    this.isShowCalendarModal = false;
  }

  // 取消日历创建弹窗
  handleCancel() {
    this.isShowCalendarModal = false;
  }

  onOpenChange(result) {
    console.log(`result`, result);
  }
}
